/**
 * 從 YouTube 網址或 11 碼影片 ID 解析出影片 ID。
 * 支援 watch?v=、youtu.be/、shorts/ 三種格式；無法解析回傳 null。
 */
export const youtubeEmbedId = (raw: string): string | null => {
  const u = raw?.trim();
  if (!u) return null;
  if (/^[a-zA-Z0-9_-]{11}$/.test(u)) return u;
  const m = u.match(/(?:v=|youtu\.be\/|shorts\/)([a-zA-Z0-9_-]{11})/);
  return m?.[1] ?? null;
};
